const initialState = {
  planningManagement: {},
  loading: true
};

export function fetchPlanningManagement(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_PLANNING_MANAGEMENT.SUCCESS':
      return {
        ...state,
        planningManagement: action.planningManagement.body,
      };
    default:
      return state
  }
}

export function savePlanningManagement(state = initialState, action) {
  switch (action.type) {
    case 'SAVE_PLANNING_MANAGEMENT.SUCCESS':
      return {
        ...state,
        planningManagement: action.planningManagement.body,
      };
    default:
      return state
  }
}
